import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/rootsbranches.webp';
import screenshot_target from '../../../images/letterfunnel/jobcouwenberg.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Job Couwenberg"
      firstname="Job"
      companyname="Roots & Branches"
      competition="Emma Sleep en WellColl"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jobcouwenberg.js